import { RuleTabEnum } from '../enum/RuleServiceV2.enum';
import i18n from 'i18next';

interface ITab {
    id: number;
    name: string;
    activeIcon?: any;
    passiveIcon?: any;
    color?: string;
    orientation?: any;
}

export const getTabConfig = (): ITab[] => {
    return [
        {
            id: RuleTabEnum.CriteriaType,
            name: i18n.t('ruleManagement.criteriaTypeV2'),
        },
        {
            id: RuleTabEnum.RuleTemplate,
            name: i18n.t('ruleManagement.ruleTemplateV2'),
        },
        { id: RuleTabEnum.Rule, name: i18n.t('ruleManagement.ruleList') },
    ];
};

export const RuleTenant = {
    0: 'Global',
    1: 'Customer',
    2: 'Payment',
    3: 'Fulfillment',
    4: 'Delivery',
    5: 'Product',
    6: 'Stock',
    7: 'Marketplace',
    8: 'Backoffice',
    9: 'YdCheckout',
    10: 'YdPostCheckout',
    11: 'YdMarketplace',
    12: 'Catalog',
    13: 'Checkout',
    14: 'Cms',
    15: 'CustomerEngagement',
    16: 'Mobile',
    17: 'Return',
    18: 'Web',
};

export const getOperators = () => {
    return [
        { label: i18n.t(`ruleManagement.operators.equalTo`), value: 0 },
        { label: i18n.t(`ruleManagement.operators.openInterval`), value: 1 },
        { label: i18n.t(`ruleManagement.operators.closedInterval`), value: 2 },
        { label: i18n.t(`ruleManagement.operators.leftClosedInterval`), value: 3 },
        { label: i18n.t(`ruleManagement.operators.rightClosedInterval`), value: 4 },
        { label: i18n.t(`ruleManagement.operators.contains`), value: 5 },
        { label: i18n.t(`ruleManagement.operators.openIntervalVersion`), value: 6 },
        { label: i18n.t(`ruleManagement.operators.closedIntervalVersion`), value: 7 },
        { label: i18n.t(`ruleManagement.operators.leftClosedIntervalVersion`), value: 8 },
        { label: i18n.t(`ruleManagement.operators.rightClosedIntervalVersion`), value: 9 },
        { label: i18n.t(`ruleManagement.operators.notEqualTo`), value: 10 },
        { label: i18n.t(`ruleManagement.operators.notContain`), value: 11 },
    ];
};
